import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IFormModel } from '../../models/form-model';
import { AssessmentFormService } from '../../services/assessment-form.service';
import { result } from 'lodash-es';
import { map } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { FieldValidators } from '../../validators/field-validators';
import { SaveFormValues } from '../../data/save-form-values';
import { serializeInitialAssessmentForm } from '../../utils/initial-assessment-serialization.util';


@Component({
  selector: 'app-save-form-dialog',
  templateUrl: './save-form-dialog.component.html',
  styleUrls: ['./save-form-dialog.component.scss']
})
export class SaveFormDialogComponent {


  @Output() onFormSaved = new EventEmitter<void>();
 
  formBuilder = inject(NonNullableFormBuilder);

  saveForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    repeatEmail: ['', Validators.required],
    password: ['', [Validators.required, FieldValidators.passwordPattern()]],
  },
{ validators: FieldValidators.mustMatch('email', 'repeatEmail') });

  isSaving = false;
  success = false;
  passwordVisibility = false;
  form: InitialAssessmentForm | null = null;

  constructor(private dialogRef: MatDialogRef<SaveFormDialogComponent>, private assessmentFormService: AssessmentFormService) {
    
   }

  ngOnInit(): void {

    // If the form is already loaded and has a loadedFormId, we can pre-fill the saveFormValues from the service and just save it without showing the dialog.
    if(this.assessmentFormService.hasFormAndLoadedFormId()) {
      this.isSaving = true;
      var saveFormValues = this.assessmentFormService.getSaveFormValues();
      var currentForm = this.assessmentFormService.getForm();
     let data: IFormModel = {
             id: currentForm?.loadedFormId || null,
             username: saveFormValues.email || '',
             pin: saveFormValues.password || '',
             formDetails: serializeInitialAssessmentForm(currentForm),
             resumeId: currentForm?.applicantDetails ? currentForm.applicantDetails.resumeLocation : null,
             decisionId: currentForm?.decision ? currentForm.decision.fileLocation : null,
             submitted: false,
             downloadedToMM: false,
             isDeleted: false
           };

      this.updateForm(data);
      }
  }
   
  saveClick(): void {
    
    if(this.saveForm.invalid) {
      this.saveForm.markAllAsTouched();
      return;
    }

    var formValues = this.getFormValues();
    
    console.log(formValues);

    this.isSaving = true;
    this.form = this.assessmentFormService.getForm();

      let data: IFormModel = {
        id: this.form?.loadedFormId || null,
        username: formValues.email || '',
        pin: formValues.password || '',
        formDetails: serializeInitialAssessmentForm(this.form),
        resumeId: this.form?.applicantDetails ? this.form.applicantDetails.resumeLocation : null,
        decisionId: this.form?.decision ? this.form.decision.fileLocation : null,
        submitted: false,
        downloadedToMM: false,
        isDeleted: false
      };

    if (!data.id || data.id === '') {
      this.initialSave(data);
    }
    else {
      this.updateForm(data);
    }
    

  }

    togglePasswordVisibility() {
    this.passwordVisibility = !this.passwordVisibility;
  }
  
    getFormValues(): SaveFormValues {
      return {
        email: this.saveForm.get('email')?.value ?? '',
        repeatEmail: this.saveForm.get('repeatEmail')?.value ?? '',
        password: this.saveForm.get('password')?.value ?? ''
      };
    }

  isValid(fieldname: string): boolean {
    const field = this.saveForm.get(fieldname);
    if (field?.invalid && (field?.touched || field?.dirty)) {
      return false;
    }
   return true;
  }

  isInvalidPasswordPattern(): boolean {

    if (this.saveForm.controls['password']?.hasError('passwordPattern') && (this.saveForm.controls['password']?.touched)) {
      return true;
    }
    return false;
  }

   private initialSave(data: IFormModel) {
    this.assessmentFormService.saveForm(data).subscribe({
     next: () => {
      this.isSaving = false;
      this.success = true;
      this.dialogRef.close('saved');
  },
  error: (error) => {
    this.isSaving = false;
    this.success = false;
    this.dialogRef.close('error');     
    } });

  }

  private updateForm(data: IFormModel) {
    this.assessmentFormService
      .updateForm(data).subscribe({
     next: () => {
      this.isSaving = false;
      this.success = true;
      this.dialogRef.close('saved');
  },
  error: (error) => {
    this.isSaving = false;
    this.success = false;
    this.dialogRef.close('error');     
    } });
  }

}